
const digest = '29629866e3e26270f883ea9f2517def914d88cca5f0c7fd491f45bf8d4d1f466';
const classes = {"wrapper":"_wrapper_1vtqa_1"};
const css = `._wrapper_1vtqa_1 {
  background: #ffffff;
  padding: 24px;
  border: 1px solid #eaedf3;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  height: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  